import React from 'react';

import Typography from 'components/Typography';
import { DateValueFormatter } from 'intl';

import { IDescriptionDate } from './interfaces';

export const DescriptionDate: React.FC<IDescriptionDate> = ({
  value,
  template = 'LLL',
  timeZone = 'local',
  ...other
}) => {
  return (
    <Typography {...other}>
      <DateValueFormatter
        value={value}
        template={template}
        timeZone={timeZone}
      />
    </Typography>
  );
};
